/**
 * Zoom inicial da camera no Jardim: 2x em qualquer tela (celular, tablet e
 * desktop). Sempre inteiro, para o pixel art cair 1:1 na tela. Vale ate o
 * jogador escolher outro nos botoes do HUD.
 */
export const DEFAULT_ZOOM = 2;

/** Limites dos botoes de zoom do HUD (passos inteiros, como o DEFAULT_ZOOM). */
export const ZOOM_MIN = 1;
export const ZOOM_MAX = 4;

const ZOOM_STORAGE_KEY = "foxygarden.zoom";

/** Zoom escolhido pelo jogador nos botoes, ou null para o padrao (DEFAULT_ZOOM). */
export function loadZoom(): number | null {
  try {
    const value = Number(localStorage.getItem(ZOOM_STORAGE_KEY));
    return Number.isInteger(value) && value >= ZOOM_MIN && value <= ZOOM_MAX ? value : null;
  } catch {
    return null;
  }
}

export function saveZoom(zoom: number): void {
  try {
    localStorage.setItem(ZOOM_STORAGE_KEY, String(zoom));
  } catch {
    // sem storage (aba privada): o zoom vale so para esta sessao
  }
}

/** Caminhos dos assets. Trocar a arte = trocar estes arquivos. */
export const ASSETS = {
  tileset: "/assets/tilesets/garden.png",
  map: "/assets/maps/garden.json",
  /** Atlas das pecas altas (arvores, estatua da Foxy, pergolado) ordenadas pela base. */
  props: { image: "/assets/props/props.png", atlas: "/assets/props/props.json" },
  avatar: (skin: number) => `/assets/sprites/avatar_${skin}.png`,
  /** Foxy NPC: 4 frames de 32x32 (andando 2, em pe, sentada). */
  foxyNpc: "/assets/sprites/foxy_npc.png",
  flappy: {
    bird: "/assets/sprites/flappy_bird.png",
    pipeBody: "/assets/sprites/flappy_pipe_body.png",
    pipeCap: "/assets/sprites/flappy_pipe_cap.png",
    skyline: "/assets/sprites/flappy_skyline.png",
    ground: "/assets/sprites/flappy_ground.png",
  },
  runner: {
    fox: "/assets/sprites/runner_fox.png",
    owl: "/assets/sprites/runner_owl.png",
    log: "/assets/sprites/runner_log.png",
    stump: "/assets/sprites/runner_stump.png",
    ground: "/assets/sprites/runner_ground.png",
    cloud: "/assets/sprites/runner_cloud.png",
  },
} as const;

/**
 * Minigames do Jardim: o slug gravado no objeto do mapa (e na tabela `games`)
 * aponta para a cena que roda a partida. Adicionar um minigame = uma linha aqui.
 */
export const MINIGAME_SCENES: Record<string, string> = {
  flappy: "flappy",
  runner: "runner",
};

/** Abas do upRanking (a placa de recordes do jardim), na ordem de exibicao. */
export const RANKING_TABS: { slug: string; name: string }[] = [
  { slug: "flappy", name: "upVoo" },
  { slug: "runner", name: "Corrida da Foxy" },
];

/** Quantidade de avatar_N.png disponiveis (precisa bater com o servidor). */
export const SKIN_COUNT = 6;

/** Tamanho de um frame do avatar, em pixels. */
export const AVATAR_FRAME = { width: 32, height: 48 } as const;

/** Camadas do mapa e a profundidade de desenho de cada uma. */
export const DEPTH = {
  ground: 0,
  decor: 1,
  /** avatares recebem depth = actors + y, para o y-sorting */
  actors: 10,
  /** copas de arvore e toldos ficam sempre acima dos jogadores */
  overhead: 20000,
  ui: 30000,
} as const;
